import { __assign, __decorate, __extends } from "tslib";
import { Component, Vue } from "vue-ext";
import VueI18n from "vue-i18n";
import VueRouter from "vue-router";
import vueDebounce from "vue-debounce";
import "./components";
import i18n from "./i18n";
Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(vueDebounce);
// always use "fi" for weee customer
var language = window.language;
if (language !== "fi") {
    language = "fi";
}
var Root = /** @class */ (function (_super) {
    __extends(Root, _super);
    function Root() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.title = "Kuusakoski Weee";
        _this.bodyClass = "";
        _this.language = null;
        _this.customerNo = null;
        _this.roles = null;
        _this.userId = null;
        _this.token = null;
        _this.isError = false;
        return _this;
    }
    Root.prototype.created = function () {
        this.customerNo = window.kkCustomerNo;
        this.roles = window.kkRoles;
        this.userId = window.kkUserId;
        this.token = window.kkToken;
        this.language = language;
    };
    Root.prototype.ackError = function () {
        this.isError = false;
    };
    Root = __decorate([
        Component({
            i18n: new VueI18n(__assign({ locale: language, fallbackLocale: "fi" }, i18n))
        })
    ], Root);
    return Root;
}(Vue));
export default Root;
